<template>
  <div>
    <div>
       <v-form ref="direccion_form" v-on:submit.prevent="saveDireccion">
        <v-row>
          <v-col sm="12" class="py-0">
            <v-text-field
              v-model="calle"
              :rules="required"
              label="Calle y Número"
              required
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12" class="py-0">
            <v-text-field
              v-model="colonia"
              :rules="required"
              label="Colonia"
              required
              clearable
            ></v-text-field>
          </v-col>
          <v-col sm="12" md="6" class="py-0">
            <v-text-field
              v-model="ciudad"
              :rules="required"
              label="Ciudad"
              required
              clearable
            ></v-text-field>
          </v-col>
          <v-col sm="12" md="6" class="py-0">
            <v-text-field
              v-model="estado"
              :rules="required"
              label="Estado"
              required
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12" class="py-0">
            <v-text-field
              v-model="observaciones"
              label="Observaciones"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row>
        <v-spacer></v-spacer>
        <v-btn text @click="saveDireccion">Guardar</v-btn>
      </v-row>
    </div>
    <Loader :showLoader="showLoader"/>
  </div>
</template>

<script>
import axios from 'axios'
import functions from '@/mixins/functions'
import Loader from '../components/Loader'
import {mapGetters} from 'vuex'

export default {
  name: 'NewAddressForm',
  components: {
    Loader
  },
  mixins: [
    functions
  ],
  props: ['selectedCliente'],
  data() {
    return {
      calle: '',
      colonia: '',
      codigo_postal: '',
      ciudad: 'Mazatlán',
      estado: 'Sinaloa',
      observaciones: '',
      lat: null,
      lng: null,
      formattedAddress: '',
      valid: true,
      required: [
        v => !!v || 'Campo Requerido'
      ],
      showLoader: false,
    }
  },
  created() {
    //console.log(this.selectedCliente)
  },
  methods: {
    saveDireccion() {
      if(this.$refs.direccion_form.validate()) {
        this.showLoader = true
        //console.log('Saving address')
        axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + this.calle + '+' + this.colonia + '+' + this.ciudad + '&key=' + this.getGoogleAPIKey)
        .then(res => {
          //console.log(res.data.results)
          //console.log('Coords', res.data.results[0].geometry)
          this.foundAddress = res.data.results
          this.formattedAddress = res.data.results[0].formatted_address
          this.lat = res.data.results[0].geometry.location.lat
          this.lng = res.data.results[0].geometry.location.lng
          //this.showLoader = false
          const data = {
            type: 'direccion_de_los_clientes',
            field_cliente_dir: {
              und: [{
                target_id: this.selectedCliente.field_nombre_cli.und[0].value + ' ' + this.selectedCliente.field_apellidos_cli.und[0].value + ' (' + this.selectedCliente.nid  + ')'
              }]
            },
            field_calle_dir: {und: [{value: this.calle}]},
            field_colonia_dir: {und: [{value: this.colonia}]},
            field_ciudad_dir: {und: [{value: this.ciudad}]},
            field_estado_dir: {und: [{value: this.estado}]},
            field_formatted_dir: {und: [{value: this.formattedAddress}]},
            field_lat_dir: {und: [{value: this.lat}]},
            field_long_dir: {und: [{value: this.lng}]},
          }
           this.setCookieToken()
          .then(() => {
            this.createNode(data)
            .then(res => {
              this.showLoader = false
              this.$store.commit('setAddress', res.data.nid)
              this.$emit('newAddressSaved')
            })
            .catch(error => {
              this.showLoader = false
              console.log(error)
            })
          })
        })
        .catch(error => console.log(error))
      }
    },
  },
  computed: {
    ...mapGetters([
      'getGoogleAPIKey',
    ])
  }
}
</script>

<style>

</style>